__turbopack_context__.v({
  "CategoryCurrent": "GridPost-module__RLYGUa__CategoryCurrent",
  "ContainerGridPost": "GridPost-module__RLYGUa__ContainerGridPost",
  "ContentBanner": "GridPost-module__RLYGUa__ContentBanner",
  "GridPost": "GridPost-module__RLYGUa__GridPost",
  "Loader": "GridPost-module__RLYGUa__Loader",
  "Loading": "GridPost-module__RLYGUa__Loading",
  "PageCurrent": "GridPost-module__RLYGUa__PageCurrent",
  "PageNumber": "GridPost-module__RLYGUa__PageNumber",
  "Pagination": "GridPost-module__RLYGUa__Pagination",
  "blogPosts": "GridPost-module__RLYGUa__blogPosts",
  "body__panel": "GridPost-module__RLYGUa__body__panel",
  "breadcrumbs": "GridPost-module__RLYGUa__breadcrumbs",
  "columns": "GridPost-module__RLYGUa__columns",
  "drop": "GridPost-module__RLYGUa__drop",
  "dropdown-toggle": "GridPost-module__RLYGUa__dropdown-toggle",
  "filterCategories": "GridPost-module__RLYGUa__filterCategories",
  "filterCategory": "GridPost-module__RLYGUa__filterCategory",
  "footer__panel": "GridPost-module__RLYGUa__footer__panel",
  "gridBlogPosts": "GridPost-module__RLYGUa__gridBlogPosts",
  "gridPostWrap": "GridPost-module__RLYGUa__gridPostWrap",
  "header__panel": "GridPost-module__RLYGUa__header__panel",
  "item__tag": "GridPost-module__RLYGUa__item__tag",
  "linesBanner": "GridPost-module__RLYGUa__linesBanner",
  "noResultsMessage": "GridPost-module__RLYGUa__noResultsMessage",
  "orderSelectors": "GridPost-module__RLYGUa__orderSelectors",
  "panelTagsActive": "GridPost-module__RLYGUa__panelTagsActive",
  "panel__tags": "GridPost-module__RLYGUa__panel__tags",
  "prixClipFix": "GridPost-module__RLYGUa__prixClipFix",
  "rotate": "GridPost-module__RLYGUa__rotate",
  "selected__numb": "GridPost-module__RLYGUa__selected__numb",
  "selectorDate": "GridPost-module__RLYGUa__selectorDate",
  "subheader__panel": "GridPost-module__RLYGUa__subheader__panel",
  "tagsTemas": "GridPost-module__RLYGUa__tagsTemas",
});
